// helper for formik subforms
export const withNamespace = (namespace: string, fieldName: string): string => {
  return namespace ? `${namespace}.${fieldName}` : fieldName;
};
